import { render } from "./Exercises.vue?vue&type=template&id=08490825&scoped=true&ts=true"
import script from "./Exercises.vue?vue&type=script&lang=ts"
export * from "./Exercises.vue?vue&type=script&lang=ts"

import "./Exercises.vue?vue&type=style&index=0&id=08490825&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08490825"]])

export default __exports__